export const DATA_MANAGEMENT_STATISTICS_REQUEST = 'DATA_MANAGEMENT_STATISTICS_REQUEST';
export const DATA_MANAGEMENT_STATISTICS_SUCCESS = 'DATA_MANAGEMENT_STATISTICS_SUCCESS';
export const DATA_MANAGEMENT_STATISTICS_FAIL = 'DATA_MANAGEMENT_STATISTICS_FAIL';

export const DATA_MANAGEMENT_PREVIEW_SUBJECTS_REQUEST = 'DATA_MANAGEMENT_PREVIEW_SUBJECTS_REQUEST';
export const DATA_MANAGEMENT_PREVIEW_SUBJECTS_SUCCESS = 'DATA_MANAGEMENT_PREVIEW_SUBJECTS_SUCCESS';
export const DATA_MANAGEMENT_PREVIEW_SUBJECTS_FAIL = 'DATA_MANAGEMENT_PREVIEW_SUBJECTS_FAIL';
export const DATA_MANAGEMENT_PREVIEW_SUBJECTS_RESET = 'DATA_MANAGEMENT_PREVIEW_SUBJECTS_RESET';

export const DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_REQUEST = 'DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_REQUEST';
export const DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_SUCCESS = 'DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_SUCCESS';
export const DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_FAIL = 'DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_FAIL';
export const DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_RESET = 'DATA_MANAGEMENT_PREVIEW_UPLOAD_BATCHES_RESET';

export const DATA_MANAGEMENT_PREVIEW_PATIENTS_REQUEST = 'DATA_MANAGEMENT_PREVIEW_PATIENTS_REQUEST';
export const DATA_MANAGEMENT_PREVIEW_PATIENTS_SUCCESS = 'DATA_MANAGEMENT_PREVIEW_PATIENTS_SUCCESS';
export const DATA_MANAGEMENT_PREVIEW_PATIENTS_FAIL = 'DATA_MANAGEMENT_PREVIEW_PATIENTS_FAIL';
export const DATA_MANAGEMENT_PREVIEW_PATIENTS_RESET = 'DATA_MANAGEMENT_PREVIEW_PATIENTS_RESET';

export const DATA_MANAGEMENT_CLEAR_SUBJECTS_REQUEST = 'DATA_MANAGEMENT_CLEAR_SUBJECTS_REQUEST';
export const DATA_MANAGEMENT_CLEAR_SUBJECTS_SUCCESS = 'DATA_MANAGEMENT_CLEAR_SUBJECTS_SUCCESS';
export const DATA_MANAGEMENT_CLEAR_SUBJECTS_FAIL = 'DATA_MANAGEMENT_CLEAR_SUBJECTS_FAIL';
export const DATA_MANAGEMENT_CLEAR_SUBJECTS_RESET = 'DATA_MANAGEMENT_CLEAR_SUBJECTS_RESET';

export const DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_REQUEST = 'DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_REQUEST';
export const DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_SUCCESS = 'DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_SUCCESS';
export const DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_FAIL = 'DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_FAIL';
export const DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_RESET = 'DATA_MANAGEMENT_CLEAR_UPLOAD_BATCHES_RESET';

export const DATA_MANAGEMENT_CLEAR_PATIENTS_REQUEST = 'DATA_MANAGEMENT_CLEAR_PATIENTS_REQUEST';
export const DATA_MANAGEMENT_CLEAR_PATIENTS_SUCCESS = 'DATA_MANAGEMENT_CLEAR_PATIENTS_SUCCESS';
export const DATA_MANAGEMENT_CLEAR_PATIENTS_FAIL = 'DATA_MANAGEMENT_CLEAR_PATIENTS_FAIL';
export const DATA_MANAGEMENT_CLEAR_PATIENTS_RESET = 'DATA_MANAGEMENT_CLEAR_PATIENTS_RESET';


